(function () {
  'use strict';

  var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var legacyKeys = ['fulfillment_method', 'fulfillment_zip', 'pickup_location_name', 'pickup_location_id', 'local_delivery_verified', 'fulfillment_confirmed_at'];
  var cleanupStarted = false;

  function addGuidance() {
    var footer = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="footer"]');
    if (!footer || footer.querySelector('[data-wtpb-checkout-guidance]')) return;
    var section = document.createElement('details');
    section.className = 'wtpb-fulfillment';
    section.setAttribute('data-wtpb-checkout-guidance', '');
    section.setAttribute('aria-labelledby', 'wtpb-checkout-guidance-title');
    var title = document.createElement('summary');
    title.id = 'wtpb-checkout-guidance-title';
    title.className = 'wtpb-fulfillment__title';
    title.textContent = 'Choose delivery or pickup in your cart';
    var detail = document.createElement('p');
    detail.className = 'wtpb-fulfillment__helper';
    detail.textContent = 'Select Shipping, Local Delivery, or Store Pickup below. For pickup, choose your route stop here. Review that selection before continuing to checkout.';
    var link = document.createElement('a');
    link.href = rootPath + 'pages/delivery-routes';
    link.textContent = 'View pickup locations and route dates';
    var rates = document.createElement('p');
    rates.className = 'wtpb-fulfillment__helper';
    rates.textContent = 'Frozen route pickup is free. Local delivery is $20. Supplier items ship separately and add their own shipping charges. Your combined shipping and delivery charge is shown at checkout.';
    section.appendChild(title);
    section.appendChild(detail);
    section.appendChild(link);
    section.appendChild(rates);
    footer.insertBefore(section, footer.firstChild);
  }

  function clearLegacyPreferences() {
    if (cleanupStarted) return;
    cleanupStarted = true;
    fetch(rootPath + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        var attributes = {};
        legacyKeys.forEach(function (key) {
          if (cart.attributes && cart.attributes[key]) attributes[key] = '';
        });
        if (!Object.keys(attributes).length) return;
        return fetch(rootPath + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart preference cleanup failed');
        });
      })
      .catch(function () { cleanupStarted = false; });
  }

  function init() {
    var unified = document.getElementById('wtx-fulfillment-config');
    if (unified) {
      try { if (JSON.parse(unified.textContent || '{}').active === true) return; } catch (error) { return; }
    }
    addGuidance();
    clearLegacyPreferences();
    new MutationObserver(addGuidance).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', function () {
      addGuidance();
      clearLegacyPreferences();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


(function () {
  'use strict';
  if (window.WTPBCartDetailsReady) return;
  window.WTPBCartDetailsReady = true;
  var queued = false;

  function enhance() {
    queued = false;
    var milestones = document.getElementById('wtx-gift-milestones');
    if (!milestones) return;
    var terms = milestones.querySelector('small');
    if (!terms) return;
    if (!document.getElementById('wtpb-cart-details-style')) {
      var style = document.createElement('style');
      style.id = 'wtpb-cart-details-style';
      style.textContent = '#rebuy-cart .wtpb-gift-summary{display:flex;align-items:center;gap:8px}#rebuy-cart .wtpb-gift-summary__text{flex:1;min-width:0;text-align:left}#rebuy-cart .wtpb-gift-details-toggle{flex:0 0 auto;margin:0;padding:4px 0;border:0!important;background:transparent;box-shadow:none;text-decoration:underline;cursor:pointer}#rebuy-cart [data-wtpb-checkout-guidance] summary{cursor:pointer}';
      document.head.appendChild(style);
    }
    if (terms.id !== 'wtpb-gift-details') terms.id = 'wtpb-gift-details';
    var toggle = milestones.querySelector('.wtpb-gift-details-toggle');
    if (!toggle) {
      var header = document.createElement('div');
      header.className = 'wtpb-gift-summary';
      var summary = document.createElement('span');
      summary.className = 'wtpb-gift-summary__text';
      summary.textContent = 'Your order rewards';
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'wtpb-gift-details-toggle';
      toggle.textContent = 'Gift details';
      toggle.setAttribute('aria-controls', terms.id);
      toggle.addEventListener('click', function () {
        var open = !milestones.classList.contains('wtpb-gift-details-open');
        milestones.classList.toggle('wtpb-gift-details-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
      header.appendChild(summary);
      header.appendChild(toggle);
      milestones.insertBefore(header, milestones.firstChild);
      milestones.classList.add('wtpb-gift-details-ready');
    }
    var expanded = String(milestones.classList.contains('wtpb-gift-details-open'));
    if (toggle.getAttribute('aria-expanded') !== expanded) toggle.setAttribute('aria-expanded', expanded);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(enhance);
  }

  function init() {
    enhance();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());


/* WTX pickup selection summary. Zapiet remains the source of fulfillment state. */
(function (root) {
  'use strict';
  if (!root || root.WTXPickupSummaryLoaded) return;
  root.WTXPickupSummaryLoaded = true;
  var selection = null, boundEvents = null, observedCart = null, observedWidget = null;
  var cartObserver = null, discoveryObserver = null, queued = false, retry = null, attempts = 0;

  function text(value) { return typeof value === 'string' || typeof value === 'number' ? String(value).trim() : ''; }
  function dateLabel(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(text(value))) return '';
    var date = new Date(value + 'T12:00:00Z');
    if (isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) return '';
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(date);
  }
  function fromEvent(params) {
    var location = params && params.location;
    if (!params || params.method !== 'pickup' || !location || !text(location.id) || !text(location.company_name)) return null;
    return {
      id: text(location.id),
      name: text(location.company_name),
      address: [text(location.address_line_1), text(location.address_line_2), [text(location.city), text(location.region_code || location.region), text(location.postal_code)].filter(Boolean).join(', ')].filter(Boolean).join('\n'),
      schedule: [dateLabel(params.date), text(params.time)].filter(Boolean).join(' · ')
    };
  }
  function bindEvents() {
    var bus = root.ZapietEvent;
    if (!bus || typeof bus.listen !== 'function' || bus === boundEvents) return;
    boundEvents = bus;
    bus.listen('selected_method', function () { selection = null; schedule(); });
    bus.listen('widget_loaded', function () { selection = null; schedule(); });
    bus.listen('locationSelected', function (params) { selection = fromEvent(params); schedule(); });
    bus.listen('checkoutEnabled', function (params) { selection = fromEvent(params); schedule(); });
  }
  function setText(node, value) { if (node.textContent !== value) node.textContent = value; }
  function ensureStyle() {
    if (document.getElementById('wtx-pickup-summary-style')) return;
    var style = document.createElement('style');
    style.id = 'wtx-pickup-summary-style';
    style.textContent = '#rebuy-cart .wtx-pickup-summary{box-sizing:border-box;margin:12px 0;padding:14px 16px;border:1px solid #b8c9b7;border-radius:10px;background:#f1f5ef;color:#243b28;text-align:left;overflow-wrap:anywhere}#rebuy-cart .wtx-pickup-summary[hidden]{display:none!important}#rebuy-cart .wtx-pickup-summary strong{display:block;font-size:16px;line-height:1.4}#rebuy-cart .wtx-pickup-summary p{margin:6px 0 0;font-size:14px;line-height:1.5;white-space:pre-line}#rebuy-cart .wtx-pickup-summary button{margin:8px 0 -4px;padding:8px 0;min-height:44px;border:0;background:transparent;box-shadow:none;color:#344c37;font:inherit;font-size:14px;text-decoration:underline;cursor:pointer}#rebuy-cart .wtx-pickup-summary button:focus-visible{outline:2px solid #5a7b5c;outline-offset:3px}';
    document.head.appendChild(style);
  }
  function createSummary(widget) {
    ensureStyle();
    var node = document.createElement('div');
    node.id = 'wtx-pickup-selection';
    node.className = 'wtx-pickup-summary';
    node.setAttribute('role', 'status');
    node.setAttribute('aria-live', 'polite');
    node.setAttribute('aria-atomic', 'true');
    var title = document.createElement('strong'); title.dataset.wtxPickupName = '';
    var address = document.createElement('p'); address.dataset.wtxPickupAddress = '';
    var timing = document.createElement('p'); timing.dataset.wtxPickupSchedule = '';
    var checkoutHelp = document.createElement('p'); checkoutHelp.dataset.wtxPickupCheckoutHelp = '';
    var change = document.createElement('button');
    change.type = 'button'; change.textContent = 'Change location'; change.setAttribute('aria-controls', 'storePickupApp');
    change.addEventListener('click', function () {
      var current = document.getElementById('storePickupApp');
      if (!current) return;
      current.scrollIntoView({ block: 'nearest' });
      var target = current.querySelector('input.locationRadio:checked') || current.querySelector('input.locationRadio');
      if (target) target.focus({ preventScroll: true });
    });
    node.appendChild(title); node.appendChild(address); node.appendChild(timing); node.appendChild(checkoutHelp); node.appendChild(change);
    widget.insertAdjacentElement('afterend', node);
    return node;
  }
  function render() {
    queued = false;
    bindEvents();
    var cart = document.getElementById('rebuy-cart');
    if (cart !== observedCart) {
      if (cartObserver) cartObserver.disconnect();
      observedCart = cart;
      if (cart) { cartObserver = new MutationObserver(schedule); cartObserver.observe(cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] }); }
    }
    var widget = cart && cart.querySelector('#storePickupApp');
    var node = cart && cart.querySelector('#wtx-pickup-selection');
    if (widget !== observedWidget) { selection = null; observedWidget = widget; }
    var active = widget && widget.querySelector('.checkoutMethod[aria-pressed="true"]');
    var pickupActive = active ? !!active.querySelector('.pickupIcon') : root.Zapiet && typeof root.Zapiet.getSelectedCheckoutMethod === 'function' && root.Zapiet.getSelectedCheckoutMethod() === 'pickup';
    if (!widget || !pickupActive) { selection = null; if (node) node.hidden = true; return; }
    var checked = widget.querySelector('input.locationRadio:checked');
    if (checked) {
      var row = checked.closest('.location');
      var name = row && row.querySelector('.name');
      var address = row && row.querySelector('.address');
      var id = checked.name.replace(/^Zapiet-Location-/, '');
      if (name && text(name.textContent)) {
        selection = { id: id, name: text(name.textContent), address: address ? text(address.innerText) : '', schedule: selection && selection.id === id ? selection.schedule : '' };
      }
    } else if (selection) {
      var listed = Array.from(widget.querySelectorAll('input.locationRadio')).find(function (input) { return input.name === 'Zapiet-Location-' + selection.id; });
      if (listed && !listed.checked) selection = null;
    }
    if (!selection) { if (node) node.hidden = true; return; }
    if (!node) node = createSummary(widget);
    setText(node.querySelector('[data-wtx-pickup-name]'), 'Pickup at ' + selection.name);
    setText(node.querySelector('[data-wtx-pickup-address]'), selection.address);
    var timing = node.querySelector('[data-wtx-pickup-schedule]');
    setText(timing, selection.schedule); timing.hidden = !selection.schedule;
    var checkoutHelp = node.querySelector('[data-wtx-pickup-checkout-help]');
    setText(checkoutHelp, 'Keep Ship selected at checkout, then confirm Route pickup is FREE.');
    node.hidden = false;
  }
  function schedule() {
    if (queued) return;
    queued = true;
    root.requestAnimationFrame(function () { try { render(); } catch (error) { queued = false; } });
  }
  function discover() {
    bindEvents(); schedule();
    if (!boundEvents && attempts++ < 120) retry = root.setTimeout(discover, 250);
  }
  function init() {
    discoveryObserver = new MutationObserver(function () {
      if (document.getElementById('rebuy-cart')) { discoveryObserver.disconnect(); schedule(); }
    });
    discoveryObserver.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('change', function (event) { if (event.target.closest && event.target.closest('#storePickupApp')) schedule(); });
    document.addEventListener('click', function (event) { if (event.target.closest && event.target.closest('#storePickupApp')) schedule(); });
    ['rebuy.loaded', 'rebuy:cart.ready', 'rebuy:smartcart.ready', 'rebuy:smartcart.show'].forEach(function (event) { document.addEventListener(event, schedule); });
    root.addEventListener('pageshow', schedule);
    discover();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(typeof window === 'undefined' ? null : window);

/* Give cart items the full drawer instead of a nested scrolling window. */
(function () {
  'use strict';
  if (document.getElementById('wtx-cart-layout-style')) return;
  var style = document.createElement('style');
  style.id = 'wtx-cart-layout-style';
  style.textContent = [
    '#rebuy-cart.rebuy-cart .rebuy-cart__flyout{height:calc(100vh - 20px)!important;height:calc(100dvh - 20px)!important;max-height:calc(100vh - 20px)!important;max-height:calc(100dvh - 20px)!important;overflow-y:auto!important;overscroll-behavior-y:contain;scrollbar-gutter:stable}',
    '#rebuy-cart.rebuy-cart .rebuy-cart__flyout>[data-rebuy-cart-anchor="header"]{position:sticky;top:0;z-index:3;background:inherit}',
    '#rebuy-cart.rebuy-cart .rebuy-cart__flyout>[data-rebuy-cart-scroll-area]{flex:0 0 auto!important;min-height:0!important;max-height:none!important;overflow:visible!important}',
    '#rebuy-cart.rebuy-cart .rebuy-cart__flyout>[data-rebuy-cart-anchor="footer"]{flex:0 0 auto!important;max-height:none!important;overflow:visible!important}',
    '#rebuy-cart.rebuy-cart .rebuy-cart__flyout-item-quantity-widget-button>*{pointer-events:none}'
  ].join('\n');
  document.head.appendChild(style);
  document.addEventListener('rebuy:smartcart.show', function () {
    window.requestAnimationFrame(function () {
      var drawer = document.querySelector('#rebuy-cart .rebuy-cart__flyout');
      if (drawer) drawer.scrollTop = 0;
    });
  });
}());

/* Remember a pickup city only. Zapiet remains responsible for eligibility and checkout. */
(function (root) {
  'use strict';
  var KEY = 'wtx.pickup-city.v1';
  var MAX_AGE = 24 * 60 * 60 * 1000;

  function validId(value) { return typeof value === 'string' && /^\d+$/.test(value); }
  function parseSaved(raw, now) {
    try {
      var value = JSON.parse(raw);
      return value && validId(value.id) && Number.isFinite(value.at) &&
        value.at <= now && now - value.at < MAX_AGE ? { id: value.id, at: value.at } : null;
    } catch (_) { return null; }
  }
  function cartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var groups = Object.create(null);
    for (var item of cart.items) {
      if (!item || !Number.isInteger(item.quantity) || item.quantity < 0) return null;
      var properties = item.properties || {};
      var identity = JSON.stringify([
        String(item.variant_id || item.id || ''),
        String(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || ''),
        Object.keys(properties).filter(function (key) { return key !== '_ZapietId'; }).sort().map(function (key) { return [key, properties[key]]; })
      ]);
      groups[identity] = (groups[identity] || 0) + item.quantity;
    }
    return JSON.stringify(Object.keys(groups).sort().map(function (key) { return [key, groups[key]]; }));
  }
  function decide(state) {
    if (state.cartKnown && state.empty) return { action: 'clear' };
    if (validId(state.selectedId)) return { action: 'adopt', id: state.selectedId };
    if (!state.saved) return { action: 'none' };
    if (!parseSaved(JSON.stringify(state.saved), state.now)) return { action: 'clear' };
    if (state.method !== 'pickup' || !state.cartKnown) return { action: 'none' };
    var key = state.signature + '|' + state.saved.id;
    if (!state.eligible || state.attemptedKey === key) return { action: 'confirm' };
    return { action: 'restore', id: state.saved.id, key: key };
  }
  if (typeof module === 'object' && module.exports) {
    module.exports = { parseSaved: parseSaved, cartSignature: cartSignature, decide: decide, MAX_AGE: MAX_AGE };
    return;
  }
  if (!root || root.WTXPickupCityPersistenceLoaded) return;
  root.WTXPickupCityPersistenceLoaded = true;
  var saved = null, attemptedKey = '', cartKnown = false, empty = false, signature = null;
  var timer = null, readTimer = null, readSequence = 0, boundBus = null, explicitOtherMethod = false;
  try { saved = parseSaved(root.sessionStorage.getItem(KEY), Date.now()); } catch (_) {}

  function remember(id, explicit) {
    if (!validId(id)) return;
    if (!saved || saved.id !== id || explicit) {
      if (!saved || saved.id !== id) attemptedKey = '';
      saved = { id: id, at: Date.now() };
      try { root.sessionStorage.setItem(KEY, JSON.stringify(saved)); } catch (_) {}
    }
  }
  function clear() {
    saved = null;
    attemptedKey = '';
    try { root.sessionStorage.removeItem(KEY); } catch (_) {}
  }
  function inputId(input) {
    var match = input && /^Zapiet-Location-(\d+)$/.exec(input.name || '');
    return match ? match[1] : '';
  }
  function showNotice(widget, show) {
    var node = document.getElementById('wtx-pickup-reconfirm');
    if (show && !node) {
      node = document.createElement('p');
      node.id = 'wtx-pickup-reconfirm';
      node.setAttribute('role', 'status');
      node.style.cssText = 'margin:12px 0;padding:12px 14px;background:#fff6e8;color:#503b1d;border:1px solid #d9bd8b;border-radius:8px;font-size:14px;line-height:1.5';
      node.textContent = 'Your cart changed. Please confirm your pickup location above before checkout.';
      widget.insertAdjacentElement('afterend', node);
    }
    if (node) node.hidden = !show;
  }
  function currentMethod(widget) {
    var active = widget && widget.querySelector('.checkoutMethod[aria-pressed="true"]');
    return active ? (active.querySelector('.pickupIcon') ? 'pickup' : 'other') :
      root.Zapiet && typeof root.Zapiet.getSelectedCheckoutMethod === 'function' ? root.Zapiet.getSelectedCheckoutMethod() : '';
  }
  function bindBus() {
    var bus = root.ZapietEvent;
    if (!bus || typeof bus.listen !== 'function' || bus === boundBus) return;
    boundBus = bus;
    ['locationSelected', 'checkoutEnabled'].forEach(function (eventName) {
      /* Payloads can arrive after a newer choice. Read the current checked control instead. */
      bus.listen(eventName, schedule);
    });
    bus.listen('widget_loaded', schedule);
    bus.listen('selected_method', schedule);
  }
  function render() {
    timer = null;
    bindBus();
    var widget = document.querySelector('#rebuy-cart #storePickupApp');
    if (!widget) return;
    if (explicitOtherMethod) { showNotice(widget, false); return; }
    var method = currentMethod(widget);
    var selected = widget.querySelector('input.locationRadio:checked');
    var target = saved && Array.from(widget.querySelectorAll('input.locationRadio')).find(function (input) { return inputId(input) === saved.id; });
    var eligible = Boolean(target && !target.disabled && target.getAttribute('aria-disabled') !== 'true' &&
      !target.closest('[aria-disabled="true"],fieldset[disabled]') &&
      target.closest('.location') && target.closest('.location').getClientRects().length);
    var result = decide({ saved: saved, now: Date.now(), cartKnown: cartKnown, empty: empty,
      signature: signature, method: method, selectedId: method === 'pickup' ? inputId(selected) : '',
      eligible: eligible, attemptedKey: attemptedKey });
    showNotice(widget, result.action === 'confirm');
    if (result.action === 'clear') clear();
    if (result.action === 'adopt') remember(result.id, false);
    if (result.action === 'restore') {
      attemptedKey = result.key;
      target.click();
      schedule();
    }
  }
  function schedule() {
    if (!timer) timer = root.setTimeout(render, 180);
  }
  function readCart() {
    readTimer = null;
    var sequence = ++readSequence;
    var path = root.Shopify && root.Shopify.routes && root.Shopify.routes.root || '/';
    fetch(path + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw Error('Cart unavailable'); return response.json(); })
      .then(function (cart) {
        if (sequence !== readSequence) return;
        var next = cartSignature(cart);
        if (next === null) return;
        signature = next;
        empty = !cart.items.some(function (item) { return item.quantity > 0; });
        cartKnown = true;
        if (empty) clear();
        schedule();
      }).catch(function () { if (sequence === readSequence) cartKnown = false; });
  }
  function changed() {
    cartKnown = false;
    ++readSequence;
    if (readTimer) root.clearTimeout(readTimer);
    readTimer = root.setTimeout(readCart, 120);
    schedule();
  }
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !event.target.closest) return;
    var button = event.target.closest('#storePickupApp .checkoutMethod');
    if (button) {
      explicitOtherMethod = !button.querySelector('.pickupIcon');
      if (explicitOtherMethod) clear();
      schedule();
    }
  }, true);
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (event.isTrusted && input.matches && input.matches('#storePickupApp input.locationRadio') && input.checked) {
      explicitOtherMethod = false;
      remember(inputId(input), true);
      schedule();
    }
  }, true);
  ['rebuy:cart.change', 'rebuy:cart.add'].forEach(function (name) { document.addEventListener(name, changed); });
  ['rebuy.loaded', 'rebuy:cart.ready', 'rebuy:smartcart.ready', 'rebuy:smartcart.show'].forEach(function (name) { document.addEventListener(name, schedule); });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  root.addEventListener('pageshow', function () { attemptedKey = ''; changed(); });
  bindBus();
  changed();
})(typeof window === 'undefined' ? null : window);
